import { render, staticRenderFns } from "./ThreadOnList.vue?vue&type=template&id=d65e3654&scoped=true&"
import script from "./ThreadOnList.vue?vue&type=script&lang=js&"
export * from "./ThreadOnList.vue?vue&type=script&lang=js&"
import style0 from "./ThreadOnList.vue?vue&type=style&index=0&id=d65e3654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65e3654",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
